import { Modal } from "@amzn/storm-ui";
import { addDays } from "date-fns";
import * as React from "react";
import { useStore } from "zustand";

import { InsightLinkageStore, SfObjectType } from "../../store/insightLinkage";
import { ContentAction } from "../../types/content";
import { formatDate } from "../../utils/date.utils";
import {
    DAYS_INTERVAL_FOR_SF_ACTIVITY_QUERY,
    NO_OPPORTUNITY_DROPDOWN_ITEM,
} from "../../utils/salesforce.utils";
import ActivityDropdown from "../common/ActivityDropdown";
import OpportunityDropdown from "../common/OpportunityDropdown";
import { OpportunityLinkageText } from "../common/OpportunityLinkageText";
import {
    ModalContainer,
    ModalContentContainer,
} from "../common/styled.components";

import { InsightLinkageFooter } from "./InsightLinkageFooter";

export const InsightLinkageModal: React.FunctionComponent = () => {
    const [open, sfObject, setSfObject, resetInsightLinkage] = useStore(
        InsightLinkageStore,
        (state) => [
            state.open,
            state.sfObject,
            state.setSfObject,
            state.resetInsightLinkage,
        ],
    );

    return (
        <Modal
            id="insight-linkage-modal"
            data-testid="insight-linkage-modal"
            isOpen={open}
            header="Add to opportunity & download"
            footer={<InsightLinkageFooter />}
            onClose={() => resetInsightLinkage()}
            padding="xsmall"
        >
            <ModalContentContainer>
                <ModalContainer>
                    <OpportunityDropdown
                        sfObject={sfObject}
                        setSfObject={setSfObject}
                        defaultOpportunity={NO_OPPORTUNITY_DROPDOWN_ITEM}
                    />
                    {sfObject.sfObjectType === SfObjectType.ACTIVITY && (
                        <ActivityDropdown
                            sfObject={sfObject}
                            setSfObject={setSfObject}
                            startDate={formatDate(new Date())}
                            endDate={formatDate(
                                addDays(
                                    new Date(),
                                    DAYS_INTERVAL_FOR_SF_ACTIVITY_QUERY,
                                ),
                            )}
                            contentAction={ContentAction.DOWNLOAD}
                        />
                    )}
                    <OpportunityLinkageText />
                </ModalContainer>
            </ModalContentContainer>
        </Modal>
    );
};
